import { useTranslation } from "react-i18next";
import React from "react";

interface Props {
  year?: number;
  hoursAccepted?: number;
  statusName?: string;
}

export const ProfessionalTrainingOverview: React.FC<Props> = ({
  year,
  hoursAccepted,
  statusName,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white px-6 py-5 rounded-md shadow-sm border border-gray-100 flex gap-12 items-center">
      <div className="flex flex-col gap-1">
        <span className="text-gray-550 text-[14px] font-normal">{t("Current Year")}</span>
        <span className="text-[24px] font-semibold text-black">{year}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-gray-550 text-[14px] font-normal">{t("Total Hours")}</span>
        <span className="text-[24px] font-semibold text-black">{hoursAccepted}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-gray-550 text-[14px] font-normal">{t("Status")}</span>
        <span className="text-[18px] font-medium text-ominimo-400">{statusName}</span>
      </div>
    </div>
  );
};
